import styles from './VerticalDivider.module.scss';

const VerticalDivider = () => {
  return <hr aria-orientation="vertical" className={styles.divider} />;
};

export { VerticalDivider };
